import { useEffect, useState } from "react";
import styles from "../dash_styles/finance.module.css";
import CurrencyDisplay from "../dash_component/CurrencyDisplay";
import { formatShortNumber } from "./formatShortAmount";
import api from "../../api/axios";

import { ResponsiveLine } from '@nivo/line';
import { ResponsivePie } from '@nivo/pie';


const Finance = () => {
    const [finance, setFinance] = useState([]);
    const [totalRevenue, setTotalRevenue] = useState(0);
    const [totalTaxes, setTotalTaxes] = useState(0);
    const [totalCost, setTotalCost] = useState(0);

    const fetchFinance = async () => {
        try {
            const res = await api.get('/order');
            const orders = res.data.orders;
            setFinance(orders);

            const revenue = orders.reduce((sum, order) => sum + (order.total || 0), 0);
            const taxes = orders.reduce((sum, order) => sum + (order.taxes || 0), 0);

            const cost = orders.reduce((sumOrders, order) => {
                if (!order.items) return sumOrders;
                const orderCost = order.items.reduce((sumItems, item) => {
                    return sumItems + (Number(item.cost) || 0) * (item.quantity || 0);
                }, 0);
                return sumOrders + orderCost;
            }, 0);

            orders.forEach(order => {
                console.log('Order:', order.id, 'Items:', order.items);
            });

            setTotalRevenue(revenue);
            setTotalTaxes(taxes);
            setTotalCost(Math.round(cost * 100) / 100);
        } catch (error) {
            console.error('Error fetching finances', error);
        }
    };

    useEffect(() => {
        fetchFinance();
    }, []);

    const profitValue = totalRevenue - totalCost - totalTaxes;

    const netProfitData = [
        { id: 'Profit', value: profitValue },
        { id: 'Cost', value: totalCost },
        { id: 'Taxes', value: totalTaxes }
    ];

    const netProfit = totalRevenue - totalCost;

    const now = new Date();
    now.setHours(0,0,0,0);

    const currentWeekStart = new Date(now);
    currentWeekStart.setDate(now.getDate() - now.getDay());

    const weeks = [];
    for(let i = 2; i >= 0; i--) {
        const start = new Date(currentWeekStart);
        start.setDate(start.getDate() - i * 7);
        const end = new Date(start);
        end.setDate(start.getDate() + 7);
        weeks.push({start, end});
    }

    const weeklyRevenues = weeks.map(({start, end}) => {
    const sum = finance.reduce((sum, order) => {
        const orderDate = new Date(order.created_at); // <-- match API
        orderDate.setHours(0,0,0,0);
        const weekStart = new Date(start); weekStart.setHours(0,0,0,0);
        const weekEnd = new Date(end); weekEnd.setHours(0,0,0,0);

        if(orderDate >= weekStart && orderDate < weekEnd) {
            return sum + (order.total || 0);
        }
        return sum;
    }, 0);
    return { start, revenue: sum };
});

    const lineData = [
        {
            id: "Revenue",
            color: "hsl(205, 70%, 50%)",
            data: weeklyRevenues.map(({start, revenue}) => {
                
                const label = start.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
                return { x: label, y: Number(revenue.toFixed(2)) };
            })
        }
    ];

    const weeklyRevenue = weeklyRevenues[2]?.revenue || 0;

    const orderCount = finance.length;
    const averageOrderValue = orderCount > 0 ? (totalRevenue / orderCount) : 0;

    const today = new Date();
    const orderCountTrend = Array.from({ length: 30 }).map((_, i) => {
        const day = new Date(today);
        day.setDate(today.getDate() - (29 - i));

        const count = finance.filter(order => {
            const orderDate = new Date(order.created_at); // match your API field
            return orderDate.getFullYear() === day.getFullYear() &&
                orderDate.getMonth() === day.getMonth() &&
                orderDate.getDate() === day.getDate();
    }).length;

    const dayStr = `${day.getMonth()+1}/${day.getDate()}`;
    return { x: dayStr, y: count };
});

const orderCountLineData = [{ id: 'Orders', data: orderCountTrend }];

    return (
        <div className={styles.mainfinance}>
            <div className={styles.topFinance}>
                <div style={{ display: 'flex', columnGap: '20px'}}>
                    <div className={styles.statCard}>
                        <div className={styles.stat} style={{ backgroundColor: 'rgba(93, 202, 54, 0.54)'}}>
                            <p>{formatShortNumber(profitValue)}</p>
                        </div>
                        <div className={styles.statInfo}>
                            <p className={styles.topText}>Net profit</p>
                            <p style={{ color: 'rgba(93, 202, 54, 0.54)'}}><CurrencyDisplay amount={profitValue} currency='CAD'/></p>
                        </div>
                    </div>
                    <div className={styles.statCard}>
                        <div className={styles.stat} style={{ backgroundColor: 'grey'}}>
                            <p>{formatShortNumber(totalRevenue)}</p>
                        </div>
                        <div className={styles.statInfo}>
                            <p className={styles.topText}>Total revenue</p>
                            <p style={{ color: 'grey'}}><CurrencyDisplay amount={totalRevenue} currency='CAD'/></p>
                        </div>
                    </div>
                    <div className={styles.statCard}>
                        <div className={styles.stat} style={{ backgroundColor: 'rgba(145, 19, 15, 0.54)'}}>
                            <p>{formatShortNumber(totalCost)}</p>
                        </div>
                        <div className={styles.statInfo}>
                            <p className={styles.topText}>Total cost</p>
                            <p style={{ color: 'rgba(145, 19, 15, 0.54)'}}><CurrencyDisplay amount={totalCost} currency='CAD'/></p>
                        </div>
                    </div>
                    <div className={styles.statCard}>
                        <div className={styles.stat} style={{ backgroundColor: 'rgba(202, 151, 54, 0.54)'}}>
                            <p>{formatShortNumber(totalTaxes)}</p>
                        </div>
                        <div className={styles.statInfo}>
                            <p className={styles.topText}>Total taxes</p>
                            <p style={{ color: 'rgba(202, 151, 54, 0.54)'}}><CurrencyDisplay amount={totalTaxes} currency='CAD'/></p>
                        </div>
                    </div>
                </div>
                <div className={styles.averageOrder}>
                    <div style={{ 
                            height: '40px', 
                            display: 'flex', 
                            columnGap: '15px', 
                            alignItems: 'center' 
                        }}>
                            <p style={{ fontWeight: 400 }}>Average order value</p>
                    </div>
                    <div className={styles.innerContent}>

                    </div>
                </div>
            </div>
            <div className={styles.bottomFinance}>
                <div className={styles.weeklyRev}>
                    <div className={styles.labelContainers}>
                        <div className={styles.label}>
                            <p>This week revenue</p>
                        </div>
                    </div>
                    <ResponsiveLine
                        data={lineData}
                        margin={{ top: 20, right: 20, bottom: 50, left: 40 }}
                        xScale={{ type: 'point' }}
                        yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: false, reverse: false }}
                        axisTop={null}
                        axisRight={null}
                        axisBottom={{
                            orient: 'bottom',
                            tickSize: 5,
                            tickPadding: 5,
                            tickRotation: 0
                        }}
                        axisLeft={{
                            orient: 'left',
                            tickSize: 5,
                            tickPadding: 5,
                            tickRotation: 0,
                        }}
                        colors="rgba(235, 213, 112, 0.72)"
                        pointSize={10}
                        pointColor={{ theme: 'background' }}
                        pointBorderWidth={2}
                        pointBorderColor={{ from: 'serieColor' }}
                        pointLabelYOffset={-12}
                        useMesh={true}
                        enableSlices="x"
                        enableGridX={false}
                        enableGridY={false}
                        curve="monotoneX"
                        height={340}
                    />
                </div>
            </div>



            {/*<div className={styles.top}>
                <div className={styles.graph}>
                    <p className={styles.dashLabel}>Net Profit</p>
                    <ResponsivePie
                        data={netProfitData}
                        margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
                        innerRadius={0.6}
                        padAngle={0.7}
                        cornerRadius={3}
                        colors={['#80b6a0', 'rgb(200, 13, 13)', 'rgb(194, 169, 26)']}
                        activeOuterRadiusOffset={8}
                        enableArcLinkLabels={false}
                        arcLabelsSkipAngle={10}
                        arcLabel={d => d.id}
                        arcLabelsTextColor={d => 'white'}
                        height={210}
                    />
                </div>
                <div className={styles.profit}>
                    <div className={styles.mainProfit}>
                        <div>
                            <div>
                                <h3>Net profit</h3>
                                <p className={styles.green}><CurrencyDisplay amount={netProfit} currency='CAD'/></p>
                            </div>
                        </div>
                        <div className={styles.profitContainer}>
                            <div>
                                <h3>Total revenue</h3>
                                <CurrencyDisplay amount={totalRevenue} currency='CAD'/>
                            </div>
                            <div>
                                <h3>Total cost</h3>
                                <p className={styles.red}><CurrencyDisplay amount={totalCost} currency='CAD'/></p>
                            </div>
                            <div>
                                <h3>Taxes</h3>
                                <p className={styles.yellow}><CurrencyDisplay amount={totalTaxes} currency='CAD'/></p>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className={styles.taxes}>
                    <p className={styles.dashLabel}>Average Order</p>
                    <div>
                        <h3>Order average value</h3>
                        <CurrencyDisplay amount={averageOrderValue} currency='CAD'/>
                    </div>
                </div>
            </div>
            <div className={styles.bottom}>
                <div className={styles.revenue}>
                    <p className={styles.dashLabel}>This Week Revenue</p>
                    <div >
                        <CurrencyDisplay amount={weeklyRevenue} currency='CAD'/>
                    </div>
                    <ResponsiveLine
                        data={lineData}
                        margin={{ top: 20, right: 20, bottom: 50, left: 40 }}
                        xScale={{ type: 'point' }}
                        yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: false, reverse: false }}
                        axisTop={null}
                        axisRight={null}
                        axisBottom={{
                            orient: 'bottom',
                            tickSize: 5,
                            tickPadding: 5,
                            tickRotation: 0
                        }}
                        axisLeft={{
                            orient: 'left',
                            tickSize: 5,
                            tickPadding: 5,
                            tickRotation: 0,
                        }}
                        colors="rgb(128, 182, 160)"
                        pointSize={10}
                        pointColor={{ theme: 'background' }}
                        pointBorderWidth={2}
                        pointBorderColor={{ from: 'serieColor' }}
                        pointLabelYOffset={-12}
                        useMesh={true}
                        enableSlices="x"
                        enableGridX={false}
                        enableGridY={false}
                        curve="monotoneX"
                        height={440}
                    />
                </div>
                
                <div className={styles.sales}>
                    <p className={styles.dashLabel}>Order count</p>
                    <div>
                        <p>{orderCount}</p>
                    </div>
                    <ResponsiveLine
                        data={orderCountLineData}
                        margin={{ top: 20, right: 20, bottom: 50, left: 40 }}
                        xScale={{ type: 'point' }}
                        yScale={{ type: 'linear', min: 0, max: 'auto' }}
                        axisTop={null}
                        axisRight={null}
                        axisBottom={{
                            orient: 'bottom',
                            tickValues: orderCountLineData[0].data.filter((_, i) => i % 3 === 0).map(d => d.x)
                        }}
                        axisLeft={{ tickSize: 5, tickPadding: 5, tickRotation: 0 }}
                        colors="rgb(128, 182, 160)"
                        pointSize={6}
                        pointColor={{ theme: 'background' }}
                        pointBorderWidth={2}
                        pointBorderColor={{ from: 'serieColor' }}
                        useMesh={true}
                        enableGridX={false}
                        enableGridY={false}
                        curve="monotoneX"
                        height={440}
                    />
                </div>
            </div>*/}
        </div>
    )
};

export default Finance;